import {Get, Post} from "../axios.config";

/** @author ljj 2020.07.08
 * 名称: 畅读卡 - 开启畅读卡
 * 
 * yapi: https://yapi.quickcan.com/project/592/interface/api/7332
 *
 *  参数                          类型      是否必须    备注
 * */

export default function v1_fox_horadric_pay(data) {
    const url       = "v1/fox/horadric/pay";
    let yapimockurl = "https://yapi.quickcan.com/mock/592/v1/fox/horadric/pay";

    return Get({url, yapimockurl, data});
}


// WEBPACK FOOTER //
// ./src/api/name/v1_fox_horadric_pay.api.js